import { Controller } from "@hotwired/stimulus"

// Lists cut to their first items: the button reveals the rest, then hides it
// again. Items past the limit are rendered hidden by the server; those marked
// data-show-more-keep stay visible.
export default class extends Controller {
  static targets = ["item", "button"]
  static values = { limit: { type: Number, default: 10 }, expanded: Boolean }

  toggle() {
    this.expandedValue = !this.expandedValue
  }

  expandedValueChanged() {
    this.itemTargets.forEach((item, index) => {
      const hidden = !this.expandedValue && index >= this.limitValue && !("showMoreKeep" in item.dataset)
      item.classList.toggle("hidden", hidden)
    })
    if (this.hasButtonTarget) {
      this.buttonTarget.textContent = this.expandedValue ? this.buttonTarget.dataset.lessLabel : this.buttonTarget.dataset.moreLabel
    }
  }
}
